import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
const smoothScroller = document.querySelector('.smooth-scroll');
const helpers = {
    smoothScrollTo: () => import('./../helpers/smooth-scroll-to'),
    updateSmoothScroll: () => import('./../helpers/smooth-scroll-update'),
    blockSmoothScroll: async () => await import('./../helpers/block-smooth-scroll'),
}
export const homepage = () => {



  function resize_ar() {
    $(".img-container-ar").each(function(){
      $(this).css("min-height",$(this).width()/$(this).attr("data-ratio"));
    });
  }
  if($(".img-container-ar").length > 0) {
    resize_ar();
    $(window).resize(function(){
      resize_ar();
    });
  }

// Check if browser is Safari
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);


// Select all video elements
const videos = document.querySelectorAll('video');

// Create a new MutationObserver for each video element
videos.forEach((video) => {
  let observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (video.classList.contains('entered') && video.paused) {
          video.play(); // Play the video
        }
      }
    }
  });

  // Start observing changes to the class attribute of the video element
  observer.observe(video, { attributes: true });
});



const investmentProposal = document.querySelector('input[value="general"]');
const generalInfo = document.querySelector('input[value="investment"]');
const fileInput = document.querySelector('#container-investment-proposal');
if(investmentProposal) {
    investmentProposal.addEventListener('change', () => {
       fileInput.style.display = 'none';
       fileInput.querySelector('input').removeAttribute('required');
       ScrollTrigger.refresh()
       helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate())
     });
  
     generalInfo.addEventListener('change', () => {
       fileInput.style.display = 'block';
       fileInput.querySelector('input').setAttribute('required', '');
       ScrollTrigger.refresh()
       helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate())
     });
}





// Select all elements with the class "text-animation"
const textElements = document.querySelectorAll('.text-animation');
const textElements2 = document.querySelectorAll('.text-animation2');
const lineElements = document.querySelectorAll('.line-animation');
const imageElements = document.querySelectorAll('.image-animation');

const headerFixed = document.querySelector('#menu-fixed header');

const bgAnimation = gsap.to("#menu-fixed header", {
  backgroundColor: "#E7DAD2",
  duration: 1.5,
  ease: "none"
});

// create the ScrollTrigger
ScrollTrigger.create({
  trigger: "main",
  scroller: smoothScroller,
  start: "top top",
  end: "500px top",
  animation: bgAnimation,
  scrub: true
});

imageElements.forEach(element => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    scroller: smoothScroller,
    trigger: element,
    start: 'top 90%',
    onEnter: () => {
      element.classList.add('image-visible');
    }
  });
});
textElements.forEach(element => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    scroller: smoothScroller,
    trigger: element,
    start: 'top 90%',
    onEnter: () => {
      element.classList.add('text-visible');
    }
  });
});
textElements2.forEach(element => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    scroller: smoothScroller,
    trigger: element,
    start: 'top 120%',
    onEnter: () => {
      element.classList.add('text-visible');
    }
  });
});
lineElements.forEach(element => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    scroller: smoothScroller,
    trigger: element,
    start: 'top 90%',
    onEnter: () => {
      element.classList.add('line-visible');
    }
  });
});


ScrollTrigger.matchMedia({
      /* 📱 mobile hero pin */
      "(min-width: 1024px)": function () {
       







//ANIMAZIONE SCHEDE VERTICALI
  if($(".sticky-images-container").length > 0) {
    ScrollTrigger.create({
    scroller: smoothScroller,
    trigger: ".sticky-images-container",
    start: "-"+$(window).height()*0.2+"px top", 
    pin: true, 
    endTrigger: "#pin-me-verticali",
    pinSpacing: false 
  });
  }
  
  if($(".full-line").length > 0) {
  ScrollTrigger.create({
    scroller: smoothScroller,
    trigger: ".full-line",
    start: "-"+$(window).height()*0.2+"px top", 
    pin: true, 
    endTrigger: "#pin-me-verticali",
    pinSpacing: false 
  });

 gsap.to(".inner-line", {
        height: "100%",
        ease:"none",
        scrollTrigger: {
          start: "-"+$(window).height()*0.2+"px top", 
          endTrigger: "#pin-me-verticali",
          scroller: smoothScroller,
          trigger: ".inner-line",
          scrub: true,
        }
  })


  }
  if($(".number-sticky").length > 0) {
  gsap.utils.toArray(".number-sticky").forEach((panel, i) => {
    ScrollTrigger.create({
      scroller: smoothScroller,
      trigger: panel,
      start: "-"+$(window).height()*0.2+"px top", 
      endTrigger: "#pin-me-verticali",
      pin: true, 
      pinSpacing: false,
      onEnter: () => {
      panel.classList.add("on-sticky");
    },
    onLeaveBack: () => {
      panel.classList.remove("on-sticky");
    }
    });
  });
}

if($(".sticky-images").length > 0) {
  gsap.utils.toArray(".sticky-images:not(:last-child) img").forEach((panel, i) => {
    gsap.to(panel, {
        y: "-100%",
        scrollTrigger: {
          scroller: smoothScroller,
          trigger: ".grid-signer[data-id='"+(i+1)+"']",
          start: "-"+$(window).height()*0.1+"px top",  //0.2
          scrub: true,
        }
    })
  });
  gsap.utils.toArray(".sticky-images:not(:first-child) .c-scale").forEach((panel, i) => {
    gsap.to(panel, {
        scale: 1,
        scrollTrigger: {
          scroller: smoothScroller,
          trigger: ".grid-signer[data-id='"+(i+1)+"']",
          start: "-"+$(window).height()*0.1+"px top",
          scrub: true,
        }
    })
  });
  gsap.utils.toArray(".sticky-images:not(:first-child) .c-scale-1").forEach((panel, i) => {
    gsap.to(panel, {
        filter: "blur(0px)",
        scrollTrigger: {
          scroller: smoothScroller,
          trigger: ".grid-signer[data-id='"+(i+1)+"']",
          start: "-"+$(window).height()*0.1+"px top",
          scrub: true,
        }
    })
  });
  }


if($(".cards-pager").length > 0) {

  const panels = document.querySelectorAll('.panel');

gsap.utils.toArray(".cards-pager").forEach((panel, i) => {
    ScrollTrigger.create({
      scroller: smoothScroller,
      trigger: panel,
      start: "top top", 
      end: "+="+(gsap.utils.toArray(".panel").length-1)*100+"%",
      pin: true, 
      pinSpacing: false 
    });
  });
gsap.utils.toArray(".panel").forEach((panel, i) => {
    const trigger = ScrollTrigger.create({
      scroller: smoothScroller,
      trigger: panel,
      start: "top top", 
      end: "+="+(($(".panel").length-1)*100 - i*100)+"%",
      pin: true, 
      anticipatePin: 1,
      pinSpacing: false,
      onLeaveBack: () => {
        $(".card-pager").removeClass("active");
        $(".card-pager[data-id='"+i+"']").addClass("active");

        if(i > 0) {
          const video_minus_1 = panels[i-1].querySelector("video");
          if (video_minus_1) {
            video_minus_1.play();
          }
        } 
      },
      onEnter: () => {
        $(".card-pager").removeClass("active");
        $(".card-pager[data-id='"+(i+1)+"']").addClass("active");
        if(i > 0) {
          const video_minus_1 = panels[i-1].querySelector("video");
          if (video_minus_1) {
            video_minus_1.pause();
          }
        } 
        if(panels.length > i+1) {
            const video_plus_1 = panels[i+1].querySelector("video");
            if(video_plus_1) {
              video_plus_1.play(); 
            }
        }
      }
    });
  });

}
if($(".fix-with-images").length > 0) {
 gsap.utils.toArray(".fix-with-images").forEach((images_text, i) => {
    ScrollTrigger.create({
      scroller: smoothScroller,
      trigger: images_text,
      start: "top top", 
      end: "+="+$(".images-up").height(),
      pin: true, 
      pinSpacing: false 
    });
  });
}

if($(".pin-me").length > 0) {
 //ANIMAZIONE DATI
  ScrollTrigger.create({
    scroller: smoothScroller,
    trigger: ".pin-me",
    start: "-150px top", 
    pin: true, 
    endTrigger: "#pin-me-marker",
    pinSpacing: false 
  });
  gsap.utils.toArray(".number-list").forEach((panel, i) => {
    ScrollTrigger.create({
      scroller: smoothScroller,
      trigger: panel,
      start: "-150px top", 
      endTrigger: "#pin-me-marker",
      pin: true, 
      pinSpacing: false 
    });
  });
 }



      },
      "(max-width: 1023px)": function () {

gsap.utils.toArray(".panel video").forEach((video, i) => {
  video.play();
})

//if($(".pin-me").length > 0) {
//  //ANIMAZIONE DATI
//  ScrollTrigger.create({
//    scroller: smoothScroller,
//    trigger: ".pin-me",
//    start: "-150px top", 
//    pin: true, 
//    endTrigger: "#pin-me-marker",
//    pinSpacing: false 
//  });
//  gsap.utils.toArray(".number-list").forEach((panel, i) => {
//    ScrollTrigger.create({
//      scroller: smoothScroller,
//      trigger: panel,
//      start: "-250px top", 
//      endTrigger: "#pin-me-marker",
//      pin: true, 
//      pinSpacing: false 
//    });
//  });
// }


      }
    }) //END MATCH MEDIA


//FOOTER
if(!$("body").hasClass("page-template-default") && !$("body").hasClass("error404") && !$("body").hasClass("page-template-contacts-feedback") && !$("html").hasClass("touch")) {
ScrollTrigger.create({
  scroller: smoothScroller,
  trigger: "footer",
  pin: true,
  pinSpacing: false,
  start: "bottom bottom",
  // endTrigger: ".container",
  end: "100%"
});
}




  $(".opacity-container").addClass("show-container");






 

// ScrollTrigger.create({
//   snap: 1 / 4 // snap whole page to the closest section!
// });


function disable_all_buttons() {
  console.log($(".book").length * 385,$(".slider").width());
  if(($(".book").length * 385) <= $(".slider").width() + 30) {
    $(".next,.prev").addClass("disabled2");
  } else {
    $(".next,.prev").removeClass("disabled2");
  }
}

if($('.inner-slider')) {
  var books_number = $(".book").length;
  var books_in_page = parseInt(($(window).width() - 80) / 385);
  $(window).resize(function(){
    books_in_page = parseInt(($(window).width() - 80) / 385);
    disable_all_buttons()
  });
  disable_all_buttons();
  var $carousel = $('.inner-slider').flickity({
  cellAlign: 'left',
  pageDots: false,
  contain: true,
  prevNextButtons: false,
  on: {
    change: function( index ) {
      if(index === 0) {
        $(".prev").addClass("disabled");
      }
      if(index >= books_number - books_in_page) {
        $(".next").addClass("disabled");
      }
      
    }}
});
$(document).on( 'click', '.next', function() {
  $carousel.flickity('next');
  $(".prev").removeClass("disabled");
});
$(document).on( 'click', '.prev', function() {
  $carousel.flickity('previous');
  $(".next").removeClass("disabled");
});



//CHANGE AREA
$(document).on( 'click', '.change-area', function(e) {
  e.preventDefault();
  if(!$(this).hasClass("button--active")) {
    $(".change-area").removeClass("button--active");
    $(this).addClass("button--active");
    var id_area = $(this).attr("href");
    $(".area").removeClass("active");
    setTimeout(function() {
      $(id_area).addClass("active");
    }, 600);
  }
});

if($("#origin-form").length) {
  setTimeout(function() {
    jQuery.ajax({
        url: ajaxurl,
        method: 'POST',
        data: {
            action: 'functions',
            function: 'get_origin',
            data: {}
        },
        success: function (response) {
          $("#origin-form").val(response);
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) { 
          consoel.log("Status: " + textStatus,"Error: " + errorThrown);
        },
      }); 
    }, 1000);
}

$(document).on( 'click', '.company-ajax', function() {
  $("#company-overlay").addClass("show-overlay");
  var id = $(this).attr("data-id");
  $(".inner-company-overlay").html("");
  $(".inner-company-overlay").removeClass("show-content");
   jQuery.ajax({
      url: ajaxurl,
      method: 'POST',
      data: {
          action: 'functions',
          function: 'get_company',
          data: {id}
      },
      success: function (response) {
        $(".inner-company-overlay").html(response);
        setTimeout(function() {$(".inner-company-overlay").addClass("show-content");}, 50);
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) { 
        consoel.log("Status: " + textStatus,"Error: " + errorThrown);
      },
    }); 

});
$(document).on( 'click', '.close-company', function() {
  $("#company-overlay").removeClass("show-overlay");

});
$(document).on( 'click', '#burger', function() {
  $("html").toggleClass("menu-mobile-out");

});


if($(".image-p").length > 0) {
gsap.utils.toArray(".image-p").forEach(element => {
  gsap.to(element, {
    yPercent: 150*element.dataset.speed,
    ease: "none",
    scrollTrigger: {
      scroller: smoothScroller,
      trigger: element,
      scrub: true,
    }
  })
});
}


//const scrollTween = gsap.to(".bar", {yPercent: 400, ease: "none", paused: true});
//
//function updateScrollBar() {
//  scrollTween.progress(scrollY / (document.body.scrollHeight - innerHeight));
//}
//document.getElementsByClassName("max-h-scroll").addEventListener("resize", updateScrollBar);
//document.getElementsByClassName("max-h-scroll").addEventListener("scroll", updateScrollBar);





}



}
